var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarMemoGoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 45,
    viewBox: "0 0 184 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_284)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4371_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0217 9.28733C12.1547 9.82049 13.6645 11.2641 14.2779 11.9192C8.9971 9.83731 7.64649 13.2565 7.64649 13.2876C10.5314 13.939 11.369 17.1653 11.4932 17.5686C11.6172 17.9718 12.8676 22.5021 12.9097 22.4601C15.2685 28.5254 20.8938 30.0703 20.811 29.9045C14.8996 22.3449 17.0971 14.7645 18.9348 11.9192C22.6603 3.7185 33.1059 0.556106 37.8629 0C35.5317 16.9298 23.1533 18.4013 23.2089 18.4013C33.6442 12.657 35.7535 2.44232 35.7312 2.38681C23.102 5.40641 19.2714 13.9323 18.9348 17.8179C18.2687 24.7007 23.061 30.6904 23.061 30.7175C25.1475 31.4491 35.7312 30.9144 35.7312 30.931C30.2661 32.5472 24.2179 32.1974 24.2179 32.214C24.2678 32.5306 28.1834 36.4461 28.2 36.4127C27.0137 35.9996 23.8846 33.2303 22.4684 31.8974C17.6164 31.4842 14.2152 28.3818 13.1211 26.8822C11.4416 25.336 10.1886 20.5841 9.77201 18.4013C9.69427 17.8126 9.19219 16.3553 7.80596 15.2356C6.4197 14.116 4.47359 13.7361 3.67383 13.6861C5.2567 12.903 4.99011 12.8363 6.03981 11.9192C6.58632 11.0123 7.73376 9.93116 8.23917 9.50391C8.69459 9.2096 9.88866 8.75416 11.0217 9.28733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9043 17.9347C22.7356 17.8737 31.4672 14.6183 35.7426 2.08472C23.9679 4.9276 18.9043 13.5621 18.9043 17.9347Z",
    fill: "#E9AE12"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8656 31.8521L76.8 34.2263C75.7449 35.2228 72.7553 36.952 69.2382 35.8969C65.721 34.8418 64.754 32.4677 64.4901 30.1815C64.4315 27.954 65.774 23.1121 71.2607 23.3231C77.0641 23.5463 77.7086 28.2764 77.5913 30.4453V30.885H68.5347C69.0036 32.2332 70.9264 34.3141 74.8656 31.8521ZM73.8983 28.5988H68.5347C68.5347 28.5988 68.9743 26.4885 71.2605 26.4006C73.0894 26.3302 73.9276 27.8367 73.8983 28.5988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.468 35.9619V28.3122C143.526 26.788 142.289 23.5464 138.28 23.476C135.643 23.4297 134.324 23.7398 132.389 24.9709C132.811 25.8853 133.503 27.1691 133.796 27.6966C134.939 27.0518 137.594 26.026 139.072 27.0811C139.551 27.6404 139.668 28.1272 139.75 28.4753C139.759 28.5103 139.767 28.5438 139.775 28.5759C137.46 28.0483 132.688 27.8901 132.125 31.4776C131.51 34.0275 133.268 35.5223 134.324 35.9619C135.378 36.4016 138.896 36.4895 139.951 34.643V35.9619H143.468ZM136.61 33.412C139.353 34.1154 139.863 32.0051 139.775 30.862C136.61 30.44 135.76 31.1552 135.731 31.5654C135.614 31.9172 135.625 32.7789 136.61 33.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.317 36.2264H116.537V24.0922H120.317V25.2353C121.443 23.7581 123.307 23.8578 124.099 24.0922C124.07 25.1767 124.028 27.3456 124.099 27.3456C121.215 26.8532 120.376 28.8404 120.317 29.8955V36.2264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4024 36.2264H40.7227V16.7273H44.6225L51.6421 28.1667L58.6618 16.7273H62.5616V36.2264H57.8818L57.6219 26.3468L52.9421 33.8865H50.3422L45.4024 26.3468V36.2264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.548 36.2264C181.093 36.2264 183.967 33.3132 183.967 29.7196C183.967 26.1261 181.093 23.2129 177.548 23.2129C174.003 23.2129 171.129 26.1261 171.129 29.7196C171.129 33.3132 174.003 36.2264 177.548 36.2264ZM177.548 33.0716C179.375 33.0716 180.854 31.5709 180.854 29.7196C180.854 27.8684 179.375 26.3677 177.548 26.3677C175.722 26.3677 174.241 27.8684 174.241 29.7196C174.241 31.5709 175.722 33.0716 177.548 33.0716Z",
    fill: "#E9AE12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.202 20.2651L166.221 23.0017L165.725 22.5041C160.558 18.7226 157.279 22.2554 156.285 24.4944C154.546 31.9581 161.005 32.2069 162.992 32.2069C164.582 32.2069 164.814 31.2117 164.731 30.7142V26.236H168.706V33.202C168.308 34.7943 165.89 35.6899 164.731 35.9387C156.186 37.531 152.393 32.124 151.565 29.2215C150.986 26.0701 151.367 19.3196 157.527 17.5284C163.688 15.7371 167.877 18.6064 169.202 20.2651Z",
    fill: "#E9AE12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.443 19.344H145.398V36.2263H149.443V19.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2243 36.2264H79.5312V24.0922H83.2243V25.1474C86.1787 22.404 89.3203 24.4146 90.522 25.7628C91.155 24.8484 92.193 24.268 92.6323 24.0922C98.5414 22.7557 99.9016 26.8766 99.8426 29.1041V36.2264H95.9742V29.3679C96.0324 28.6059 95.6925 27.0818 93.864 27.0818C92.0345 27.0818 91.5776 28.6059 91.5776 29.3679V36.2264H87.8845V29.3679C87.8845 28.6352 87.4097 27.1522 85.5105 27.0818C83.6111 27.0114 83.195 28.5765 83.2243 29.3679V36.2264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.19 36.2264C111.735 36.2264 114.608 33.3132 114.608 29.7196C114.608 26.1261 111.735 23.2129 108.19 23.2129C104.645 23.2129 101.771 26.1261 101.771 29.7196C101.771 33.3132 104.645 36.2264 108.19 36.2264ZM108.19 33.0716C110.016 33.0716 111.496 31.5709 111.496 29.7196C111.496 27.8684 110.016 26.3677 108.19 26.3677C106.364 26.3677 104.884 27.8684 104.884 29.7196C104.884 31.5709 106.364 33.0716 108.19 33.0716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.071 25.9001L126.025 25.853V36.2264H130.071V25.9001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07 20.3306H126.025V24.3865H130.07V20.3306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4371_284",
    x: 0.152297,
    y: 0,
    width: 41.2325,
    height: 43.4559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4371_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4371_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 44.0191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarMemoGoLogo);
export default __webpack_public_path__ + "static/media/side-bar-memo-go-logo.6b189163665fab06153a3521bff7ff3a.svg";
export { ForwardRef as ReactComponent };